import React from "react";
import { Stack } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import ReworkStationTableRow from "./ReworkStationTableRow";

const ReworkStationTableBody = ({
  fields = [],
  remove = () => {},
  move = () => {},
}) => {
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const start = result.source.index;
    const end = result.destination.index;

    move(start, end);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="rework-stations">
        {(provided) => (
          <Stack {...provided.droppableProps} ref={provided.innerRef}>
            {fields?.map((item, idx) => {
              const key = item.id;
              const props = { idx, item, remove };

              return (
                <Draggable key={key} draggableId={key} index={idx}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <ReworkStationTableRow key={key} {...props} />
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </Stack>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ReworkStationTableBody;
